import React from 'react';
import { Box, BoxProps } from '@mui/material';

export interface ImageThumbnailProps extends Omit<BoxProps, 'children'> {
  alt: string;
  children?: React.ReactNode;
  imageProps?: Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'alt' | 'src'>;
  size?: number;
  src: string;
}

const thumbnailStyles = {
  position: 'relative',
  flex: '0 0 auto',
  overflow: 'hidden',
  boxSizing: 'border-box',
  border: '1px solid',
  borderColor: 'softBorder',
  borderRadius: '4px',
  '& > img': {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};

const ImageThumbnail = React.memo(
  ({
    alt,
    children,
    imageProps,
    size = 150,
    src,
    sx,
    ...boxProps
  }: ImageThumbnailProps) => (
    <Box
      height={size}
      width={size}
      sx={[thumbnailStyles, ...(Array.isArray(sx) ? sx : [sx])]}
      {...boxProps}
    >
      <img alt={alt} src={src} {...imageProps} />
      {children}
    </Box>
  )
);

ImageThumbnail.displayName = 'ImageThumbnail';

export { ImageThumbnail };
